import { Button, Form, Input, Select, Switch } from "antd";
import { Category } from "@types";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAddCategory, useEditCategory, useGetCategories } from "@hooks";

interface Props {
  category?: Category;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CategoryForm = ({ category, setIsModalOpen }: Props) => {
  const [categoryForm] = Form.useForm();
  const { t } = useTranslation();
  const addCategory = useAddCategory();
  const editCategory = useEditCategory();
  const { data, isLoading } = useGetCategories();

  useEffect(() => {
    if (category) {
      categoryForm.setFieldsValue(category)
    }
  }, [category]);

  const onSubmit = (values: any) => {
    values = { ...values};
    if (category) {
      const val = { ...values, id: category.id, questionType: "766d7fba-d71d-4ef7-a975-5604aa4427b1" };
      editCategory.mutate(val, {
        onSuccess() {
          setIsModalOpen(false);
        }
      });
    } else {
      addCategory.mutate(values, {
        onSuccess() {
          setIsModalOpen(false);
        }
      });
    }
    
  };

  return (
    <Form layout="vertical" form={categoryForm} onFinish={onSubmit}>
      <Form.Item
        name={["name"]}
        label={t("forms.category.categoryName")}
        rules={[{ required: true, message: t("forms.category.categoryDesc") }]}
      >
        <Input placeholder={t("forms.category.categoryDesc")} />
      </Form.Item>
      <Form.Item label={t("forms.category.forQuiz")} name={["availableForQuiz"]} valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item
        name={["parentId"]}
        label={t("forms.category.parentCategory")}
      >
        <Select
          allowClear
          maxCount={1}
          filterOption={(input, option: any) =>
            option?.label!.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          showSearch
          loading={isLoading}
          placeholder={t("forms.category.parentDesc")}
          options={data?.map((categoryLoc: Category) => ({
            label: categoryLoc.name,
            value: categoryLoc.id,
            disabled: category?.id === categoryLoc.id,
          }))}
        />
      </Form.Item>
      <Form.Item
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          marginBottom: 0,
        }}
      >
        <Button
          type="primary"
          htmlType="submit"
          loading={category ? editCategory.isPending : addCategory.isPending}
        >
          {t("forms.category.save")}
        </Button>
      </Form.Item>
    </Form>
  );
};
